"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketStatisticsOutcode$ = exports.MarketStatisticsOutcode$outboundSchema = exports.MarketStatisticsOutcode$inboundSchema = void 0;
exports.marketStatisticsOutcodeToJSON = marketStatisticsOutcodeToJSON;
exports.marketStatisticsOutcodeFromJSON = marketStatisticsOutcodeFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const propertytypemarketstats_js_1 = require("./propertytypemarketstats.js");
const salesdetailsbymonthitem_js_1 = require("./salesdetailsbymonthitem.js");
const salesdetailsbypriceitem_js_1 = require("./salesdetailsbypriceitem.js");
const salesdetailsbyyearitem_js_1 = require("./salesdetailsbyyearitem.js");
/** @internal */
exports.MarketStatisticsOutcode$inboundSchema = z.object({
    average_price_properties_sold_last_12_months: z.nullable(z.number().int()),
    count_of_properties: z.number().int(),
    count_total_properties_sold_last_12_months: z.nullable(z.number().int()),
    detached_statistics: z.nullable(propertytypemarketstats_js_1.PropertyTypeMarketStats$inboundSchema),
    flats_maisonettes_statistics: z.nullable(propertytypemarketstats_js_1.PropertyTypeMarketStats$inboundSchema),
    outcode: z.string(),
    sales_monthly: z.nullable(z.array(salesdetailsbymonthitem_js_1.SalesDetailsByMonthItem$inboundSchema)),
    sales_price_bracket: z.nullable(z.array(salesdetailsbypriceitem_js_1.SalesDetailsByPriceItem$inboundSchema)),
    sales_yearly: z.nullable(z.array(salesdetailsbyyearitem_js_1.SalesDetailsByYearItem$inboundSchema)),
    semi_detached_statistics: z.nullable(propertytypemarketstats_js_1.PropertyTypeMarketStats$inboundSchema),
    terraced_statistics: z.nullable(propertytypemarketstats_js_1.PropertyTypeMarketStats$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_price_properties_sold_last_12_months": "averagePricePropertiesSoldLast12Months",
        "count_of_properties": "countOfProperties",
        "count_total_properties_sold_last_12_months": "countTotalPropertiesSoldLast12Months",
        "detached_statistics": "detachedStatistics",
        "flats_maisonettes_statistics": "flatsMaisonettesStatistics",
        "sales_monthly": "salesMonthly",
        "sales_price_bracket": "salesPriceBracket",
        "sales_yearly": "salesYearly",
        "semi_detached_statistics": "semiDetachedStatistics",
        "terraced_statistics": "terracedStatistics",
    });
});
/** @internal */
exports.MarketStatisticsOutcode$outboundSchema = z.object({
    averagePricePropertiesSoldLast12Months: z.nullable(z.number().int()),
    countOfProperties: z.number().int(),
    countTotalPropertiesSoldLast12Months: z.nullable(z.number().int()),
    detachedStatistics: z.nullable(propertytypemarketstats_js_1.PropertyTypeMarketStats$outboundSchema),
    flatsMaisonettesStatistics: z.nullable(propertytypemarketstats_js_1.PropertyTypeMarketStats$outboundSchema),
    outcode: z.string(),
    salesMonthly: z.nullable(z.array(salesdetailsbymonthitem_js_1.SalesDetailsByMonthItem$outboundSchema)),
    salesPriceBracket: z.nullable(z.array(salesdetailsbypriceitem_js_1.SalesDetailsByPriceItem$outboundSchema)),
    salesYearly: z.nullable(z.array(salesdetailsbyyearitem_js_1.SalesDetailsByYearItem$outboundSchema)),
    semiDetachedStatistics: z.nullable(propertytypemarketstats_js_1.PropertyTypeMarketStats$outboundSchema),
    terracedStatistics: z.nullable(propertytypemarketstats_js_1.PropertyTypeMarketStats$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averagePricePropertiesSoldLast12Months: "average_price_properties_sold_last_12_months",
        countOfProperties: "count_of_properties",
        countTotalPropertiesSoldLast12Months: "count_total_properties_sold_last_12_months",
        detachedStatistics: "detached_statistics",
        flatsMaisonettesStatistics: "flats_maisonettes_statistics",
        salesMonthly: "sales_monthly",
        salesPriceBracket: "sales_price_bracket",
        salesYearly: "sales_yearly",
        semiDetachedStatistics: "semi_detached_statistics",
        terracedStatistics: "terraced_statistics",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var MarketStatisticsOutcode$;
(function (MarketStatisticsOutcode$) {
    /** @deprecated use `MarketStatisticsOutcode$inboundSchema` instead. */
    MarketStatisticsOutcode$.inboundSchema = exports.MarketStatisticsOutcode$inboundSchema;
    /** @deprecated use `MarketStatisticsOutcode$outboundSchema` instead. */
    MarketStatisticsOutcode$.outboundSchema = exports.MarketStatisticsOutcode$outboundSchema;
})(MarketStatisticsOutcode$ || (exports.MarketStatisticsOutcode$ = MarketStatisticsOutcode$ = {}));
function marketStatisticsOutcodeToJSON(marketStatisticsOutcode) {
    return JSON.stringify(exports.MarketStatisticsOutcode$outboundSchema.parse(marketStatisticsOutcode));
}
function marketStatisticsOutcodeFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.MarketStatisticsOutcode$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MarketStatisticsOutcode' from JSON`);
}
//# sourceMappingURL=marketstatisticsoutcode.js.map